// extracted by mini-css-extract-plugin
module.exports = {"Title":"Title___1NwYy","SuggistionsListWrap":"SuggistionsListWrap___2l7QD","Link":"Link___3_Kqr","loading":"loading___1irP-"};